import classNames from 'classnames';

import { CloseBoldV2Icon, ExclamationTriangleIcon } from '../../icons';

import styles from './_index.module.scss';

export interface PillProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonRef?: React.Ref<HTMLButtonElement>;
  className?: string;
  'data-testid'?: string;
  header?: React.ReactNode;
  icon?: React.ReactNode;
  isActive?: boolean;
  isBold?: boolean;
  isCompleted?: boolean;
  isDisabled?: boolean;
  isError?: boolean;
  isModified?: boolean;
  isRequired?: boolean;
  onClick?: () => void;
  onClose?: () => void;
  value?: string | number;
}

const Pill = ({
  buttonRef,
  className,
  'data-testid': dataTestId = 'pill',
  icon,
  isActive,
  isBold = true,
  isCompleted,
  isDisabled,
  isError,
  isModified,
  isRequired,
  onClick = () => {},
  onClose,
  value,
  ...props
}: PillProps) => {
  const handleOnClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClose) {
      event.stopPropagation();
      onClose();
    }
  };
  const otherClassNames = {
    [styles['is-active']]: isActive && !isDisabled && !isCompleted,
    [styles['is-completed']]: isCompleted,
    [styles['is-disabled']]: isDisabled && !isRequired && !isCompleted,
    [styles['is-error']]: isError,
  };

  return (
    <button
      aria-label="pill"
      className={classNames(styles['pill'], className, otherClassNames)}
      data-testid={dataTestId}
      onClick={isCompleted || isDisabled ? () => {} : onClick}
      ref={buttonRef}
      {...props}
    >
      {isError && (
        <span className={styles['pill-icon']}>
          <ExclamationTriangleIcon data-testid="error-icon" />
        </span>
      )}
      {!isError && icon && <span className={styles['pill-icon']}>{icon}</span>}
      {(value || value === 0) && (isBold ? <strong>{value}</strong> : value)}
      {isModified && !isDisabled && !isCompleted && (
        <CloseBoldV2Icon
          className={styles['pill-close-icon']}
          data-testid="close-bold-icon"
          // @ts-ignore - onClick on an svg element, should be moved
          onClick={handleOnClose}
        />
      )}
      {isRequired && !isModified && !isCompleted && (
        <span className={styles['pill-required-icon']}>*</span>
      )}
    </button>
  );
};

export default Pill;
